import { CarStatus } from '../../../../types'
import { mapCarStatus } from '../../../../utils/helpers/helpers.cars'
import { getButtonClasses } from '../../components/V3/_shared/Pill'

export function StatusBadge({ status }: { status: string }) {
  let styles = ''
  switch (status) {
    case CarStatus.Order: {
      styles = `${getButtonClasses({ color: 'blue' })} border-blue-400`
      break
    }
    case CarStatus.Active: {
      styles = `${getButtonClasses({ color: 'green' })} border-green-400`
      break
    }
    case CarStatus.Closed: {
      styles = `${getButtonClasses({ color: 'purple' })} border-purple-800`
      break
    }
    case CarStatus.Administrated: {
      styles = 'bg-blue-100 text-blue-800 border-blue-400'
      break
    }
    default:
      break
  }

  return (
    <span
      className={`font-extrabold px-4 py-1 rounded-md capitalize text-xs border-[1px] ${styles}`}
    >
      {mapCarStatus(status)}
    </span>
  )
}
